import { createBrowserRouter, Navigate } from 'react-router-dom';
import { IdentifyPage } from '../pages/IdentifyPage';
import { GenericIdentifyPage } from '../pages/GenericIdentifyPage';
import { MemoryPage } from '../pages/MemoryPage';
import App from '../App';
import { AdminLoginPage } from '../pages/admin/LoginPage';
import { DashboardPage } from '../pages/admin/DashboardPage';
import { QuickPrintOrdersPage } from '../pages/admin/QuickPrintOrdersPage';
import { OrdersPage } from '../pages/admin/OrdersPage';
import { ItemsPage } from '../pages/admin/ItemsPage';
import { ItemFormPage } from '../pages/admin/ItemFormPage';
import { SettingsPage } from '../pages/admin/SettingsPage';
import { AmbientPhotosPage } from '../pages/admin/AmbientPhotosPage';
import { ClientsPage } from '../pages/admin/ClientsPage';
import { GenericVideosPage } from '../pages/admin/GenericVideosPage';
import { GenericVideoFormPage } from '../pages/admin/GenericVideoFormPage';
import { AdminLayout } from '../components/admin/layouts/AdminLayout';
import { ProtectedRoute } from '../components/admin/ProtectedRoute';
import { ManagerOnlyRoute } from '../components/admin/ManagerOnlyRoute';
import { AdminHomeRedirect } from '@/components/admin/AdminHomeRedirect';
import { ExternalRedirect } from '../components/ExternalRedirect';
import { RootLayout } from '../components/RootLayout';
import { SimpleOrdersPage } from '../pages/desk/SimpleOrdersPage';
import { AudioCatalog } from '../pages/superadmin/AudioCatalog';
import { VideoSettings } from '../pages/admin/VideoSettings';
import { UserManagementPage } from '../pages/superadmin/UserManagementPage';
import { RestaurantManagementPage } from '../pages/superadmin/RestaurantManagementPage';
import { OrderRedirect } from './OrderRedirect';

export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    children: [
      {
        path: '/',
        element: <ExternalRedirect />,
      },
      {
        path: '/health',
        element: <App />,
      },
      {
        path: '/desk',
        element: <Navigate to="/admin/orders" replace />,
      },
      {
        path: '/desk/simple',
        element: (
          <ProtectedRoute>
            <SimpleOrdersPage />
          </ProtectedRoute>
        ),
      },
      {
        path: '/orders/:providerOrderId',
        element: <IdentifyPage />,
      },
      {
        path: '/g/:slug',
        element: <GenericIdentifyPage />,
      },
      {
        path: '/order/:providerOrderId',
        element: <OrderRedirect />,
      },
      {
        path: '/memory/:slug',
        element: <MemoryPage />,
      },
      {
        path: '/admin/login',
        element: <AdminLoginPage />,
      },
      {
        path: '/admin',
        element: (
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        ),
        children: [
          {
            index: true,
            element: <AdminHomeRedirect />,
          },
          {
            path: 'orders',
            element: <QuickPrintOrdersPage />,
          },
          {
            // El personal solo tiene Órdenes; el resto le devuelve allí (spec 012)
            element: <ManagerOnlyRoute />,
            children: [
              {
                path: 'dashboard',
                element: <DashboardPage />,
              },
              {
                path: 'orders/detail',
                element: <OrdersPage />,
              },
              {
                path: 'items',
                element: <ItemsPage />,
              },
              {
                path: 'items/:id/edit',
                element: <ItemFormPage />,
              },
              {
                path: 'ambient-photos',
                element: <AmbientPhotosPage />,
              },
              {
                path: 'clients',
                element: <ClientsPage />,
              },
              {
                path: 'settings',
                element: <SettingsPage />,
              },
              {
                path: 'video-settings',
                element: <VideoSettings />,
              },
              {
                path: 'generic-videos',
                element: <GenericVideosPage />,
              },
              {
                path: 'generic-videos/new',
                element: <GenericVideoFormPage />,
              },
              {
                path: 'generic-videos/:id/edit',
                element: <GenericVideoFormPage />,
              },
            ],
          },
        ],
      },
      {
        path: '/superadmin',
        element: (
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        ),
        children: [
          {
            path: 'users',
            element: <UserManagementPage />,
          },
          {
            path: 'restaurants',
            element: <RestaurantManagementPage />,
          },
          {
            path: 'audio-catalog',
            element: <AudioCatalog />,
          },
        ],
      },
      {
        path: '*',
        element: <ExternalRedirect />,
      },
    ],
  },
]);
